<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="nome"
    label="Banco"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <span>
          {{item.item.codigo}} - {{item.item.nome}}
        </span>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import BancoService from '@/api/banco-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchGrupo(val) {
      const isSelected = this.localValue && this.localValue.nome === val;

      const searchValue = isSelected || !val ? '' : val;

      this.loading = true;
      const searchText = searchValue.toLowerCase();
      BancoService.list({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `codigo like "%${searchText}%" or nome like "%${searchText}%" order by codigo`,
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value) {
            this.items = [...this.items, this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchGrupo, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
